import { PaywallAuthErrorCodes, SiteLinks, PaywallPlans } from "../../../../../global/paywall/paywallInterfaces";
import { HyperLinkBuilder } from "widgets/commonComponents/inline/hyperLink"
import { PremiumPaywallState } from "../premiumPaywallDesktop";
import { getNewlinkTargetProperties } from "../../../ynet1280/ynetShops/data/ynetshopsData";

declare const window: Window & {
  PAYWALL_PLANS: PaywallPlans
  PAYWALL_SITE_LINKS: SiteLinks;
}

interface PremiumPaywallDesktopSignupEmailProps {
  emailOrPhone: string
  agreesTerms: boolean
  setEmailOrPhone: (emailOrPhone: string) => void
  setAgreesTerms: (agreesTerms: boolean) => void
  setMode: (state: PremiumPaywallState) => void
  loginWithGoogle: () => void
  loginWithApple: () => void
  sendMail: () => void
  authError: string
  setAuthError: (error: PaywallAuthErrorCodes) => void;
}

const errorMessagesFront: Partial<Record<PaywallAuthErrorCodes, string>> = {
  [PaywallAuthErrorCodes.INVALID_EMAIL]: 'כתובת דוא"ל אינה תקינה',
  [PaywallAuthErrorCodes.SIGNUP_NO_AGREEMENT]: `חובה לאשר את תנאי השימוש`,
};

const errorMessagesServer: Partial<Record<PaywallAuthErrorCodes, string>> = {
  [PaywallAuthErrorCodes.EMAIL_ALREADY_EXISTS]: 'כתובת הדוא"ל כבר קיימת במערכת',
  [PaywallAuthErrorCodes.FAILED_TO_SEND_OTP]: "אירעה שגיאה במערכת, אנא נסו שוב מאוחר יותר",
  [PaywallAuthErrorCodes.ALREADY_SIGNED]: "משתמש קיים במערכת",
  [PaywallAuthErrorCodes.OTP_MAX_ATTEMPTS]: "חרגת ממספר בקשות אימות. יש לפנות לשירות לקוחות",
}



export const PremiumPaywallDesktopSignupEmail = (props: PremiumPaywallDesktopSignupEmailProps) => {

  const { emailOrPhone, setEmailOrPhone, agreesTerms, setAgreesTerms, loginWithApple, loginWithGoogle, setMode, sendMail, authError, setAuthError } = props
  const targetLink = getNewlinkTargetProperties();
  const handleMailChange = (e) => {
    setEmailOrPhone(e.target.value)
    if (e.target.value.length === 0 && authError) {
      setAuthError(null);
    }
  }

  const handleAgreeChange = (e) => {
    setAgreesTerms(e.target.checked)
    if (e.target.checked) {
      setAuthError(null);
      const handleAgreeTerms = new Event("handleAgreeTerms")
      document.dispatchEvent(handleAgreeTerms);
    }
  }

  const handleSendMail = () => {
    sendMail()
  }


  const handlePressKey = (e) => {
    if (e.key === 'Enter') {
      handleSendMail();
    }
  }
const loginEvent =(mode)=>{
    setMode({ mode: mode })    
    const loginButtonEvent = new CustomEvent("loginButtonEvent",   { detail: {  mode: mode } })
    document.dispatchEvent(loginButtonEvent);
}
const handleNewspaperRegister = () => {
    setMode({ mode: 'signIn', isNewspaper: true })
    const newspaperRegisterEvent = new CustomEvent("handleNewspaperRegister")
    document.dispatchEvent(newspaperRegisterEvent);
}

  const handleThirdPartyLogin = (loginMethod: () => void) => {
    if (agreesTerms) {
      loginMethod();
      const handleThirdPartyLogin = new CustomEvent("handleThirdPartyLogin", { detail: { loginMethod: loginMethod === loginWithGoogle ? "google" : "apple",  type: "signup"  } });
      document.dispatchEvent(handleThirdPartyLogin);

    } else {
      setAuthError(PaywallAuthErrorCodes.SIGNUP_NO_AGREEMENT);
    }
  }

  const handleEmailReset = () => {
    setEmailOrPhone('');
    setAuthError(null);
  }


  const termsUrl = typeof window !== "undefined" && window.PAYWALL_SITE_LINKS ? window.PAYWALL_SITE_LINKS.terms : '';
  const privacyUrl = typeof window !== "undefined" && window.PAYWALL_SITE_LINKS ? window.PAYWALL_SITE_LINKS.privacy : '';


  return (
    <div className="premium-paywall-desktop-signup-email">
      <h1 className="title">יצירת חשבון</h1>
      <div className="subtitle">הזינו את כתובת הדוא"ל</div>
      <div className={`email-signup ${authError ? (authError.includes('EMAIL') ? 'error email' : 'error') : ''}`}>
        <input onKeyPress={handlePressKey} value={emailOrPhone} onChange={handleMailChange} type="email" placeholder='הקלידו כתובת דוא"ל' />
        {emailOrPhone && <div className="reset-icon" onClick={handleEmailReset}></div>}
        {
          authError === PaywallAuthErrorCodes.INVALID_EMAIL ? (
            <p className="error-text">{errorMessagesFront[authError]}</p>
          ) : (
            <p
              className="error-text"
              dangerouslySetInnerHTML={{ __html: errorMessagesServer[authError] }}
            />
          )
        }
      </div>
      <div className="buttons-container">
        <button disabled={!emailOrPhone.length} className="button-base continue" onClick={handleSendMail}>המשך</button>
      </div>
      <div className="separator">
        <div className="line" />
        <span className="text">או באמצעות</span>
        <div className="line" />
      </div>      <div className="social-signup">
        <button className="social-button google-btn" onClick={() => handleThirdPartyLogin(loginWithGoogle)}><span>גוגל</span></button>
        <button className="social-button apple-btn" onClick={() => handleThirdPartyLogin(loginWithApple)}><span>אפל</span></button>
      </div>

      <div className={`terms ${authError && authError === PaywallAuthErrorCodes.SIGNUP_NO_AGREEMENT ? 'error' : ''}`}>
        <div className="inner-container">
          <input type="checkbox" checked={agreesTerms} onChange={handleAgreeChange} />
          <span className="text">מסכים/ה ל<HyperLinkBuilder linkTarget={targetLink} href={termsUrl}>תנאי השימוש</HyperLinkBuilder>, <HyperLinkBuilder linkTarget={targetLink} href={privacyUrl}>מדיניות פרטיות</HyperLinkBuilder>, וקבלת פניות שיווקיות כולל טלפוניות.<br />הודעות תפעוליות ימשיכו להישלח בתקופת המינוי גם לאחר הסרתי מרשימת מדוורים.</span>
        </div>
        <p className="error-text">
          {authError === PaywallAuthErrorCodes.SIGNUP_NO_AGREEMENT ? (
            <span dangerouslySetInnerHTML={{ __html: errorMessagesFront[authError] }} />
          ) : <span> </span>}
        </p>
      </div>





      <div className="login">
        <div>כבר מנויים? <button type="button" onClick={() => loginEvent('signIn')}>כניסה</button></div>
      </div>
      <div className="newspaper-users" >
        <div><span>מנויים לעיתון</span> <span className="yedioth-label"></span></div>
        <div onClick={() => handleNewspaperRegister()} className="newspaper-register-text">צרו חשבון ל-<div className="yedioth-plus-label"></div>ללא עלות</div>
      </div>
    </div>

  )
}
